import { TableCell, TableSortLabel } from '@mui/material'
import React from 'react'

type AlignOptions = 'left' | 'center' | 'right' | 'justify' | 'inherit' | undefined

interface ISortedTableCellProps {
  orderBy: string
  order: string
  columnName: string
  propertyName: string
  onClick: (propertyName: string) => void
  align?: AlignOptions
  style?: React.CSSProperties | undefined
  sortable?: boolean
  colSpan?: number
  reserveSortIconSpace?: boolean
}
function SortedTableCell(props: ISortedTableCellProps) {
  type OrderDirection = 'asc' | 'desc' | undefined
  const sortable = props.sortable !== false
  const isSorted = sortable && props.orderBy === props.propertyName

  return (
    <TableCell align={props.align} style={props.style} colSpan={props.colSpan}>
      <TableSortLabel
        active={isSorted}
        hideSortIcon={!props.reserveSortIconSpace}
        disabled={!sortable}
        direction={
          props.orderBy === props.propertyName ? (props.order as OrderDirection) : 'asc'
        }
        aria-label={props.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
        onClick={sortable ? () => props.onClick(props.propertyName) : undefined}
        sx={{
          fontWeight: 'inherit',
          fontSize: 'inherit',
          '&.Mui-disabled': { cursor: 'default', color: 'inherit' },
          '& .MuiTableSortLabel-icon': { fontSize: '14px', margin: 0 },
        }}
      >
        {props.columnName}
      </TableSortLabel>
    </TableCell>
  )
}
export default SortedTableCell

export const sortedTableHeaderSx = {
  '& thead th': {
    fontWeight: 600,
    fontSize: '0.9rem',
    lineHeight: 1.2,
    paddingTop: '6px',
    paddingBottom: '6px',
    borderBottom: '1px solid #bdbdbd',
  },
  '& thead th .MuiTableSortLabel-root, & thead th .MuiTableSortLabel-root.Mui-active': {
    fontWeight: 600,
  },
}
